require("!!/home/hellomojito/agency-space/node_modules/script-loader/addScript.js")(require("!!/home/hellomojito/agency-space/node_modules/raw-loader/index.js!/home/hellomojito/agency-space/assets/plugins/interactjs/interact.min.js"))


//////////////////
// WEBPACK FOOTER
// ./assets/plugins/interactjs/interact.min.js
// module id = 706
// module chunks = 0